import React from 'react';
import { X } from 'lucide-react';

const Input = ({
  disabled = false,
  label,
  name,
  type = 'text',
  step,
  min,
  max,
  placeholder,
  required = false,
  value,
  onChange,
  onKeyDown,
  onClear,
  autoFocus = false,
}) => {
  const showClear = Boolean(onClear) && Boolean(value);

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          required={required}
          disabled={disabled}
          step={step}
          min={min}
          max={max}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
          className={`w-full border border-bluePale rounded-xl px-3 py-3 text-base placeholder-blueSteel ${
            showClear ? 'pr-10' : ''
          }`}
        />

        {showClear && (
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={onClear}
            title="Limpar"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-blueSteel hover:text-blueDarker transition-colors"
          >
            <X size={16} strokeWidth={2} />
          </button>
        )}
      </div>
    </div>
  );
};

export default Input;
